import React from "react"
import "./style.css"
import Heading from "../Heading"
import Button from "../WinpeButton"
import PropTypes from "prop-types"

export class Event extends React.Component {
	constructor (args) {
		super(args)
		this.state = {
			activeIndex: 1
		}
		this.eventDetails = {
			1: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			2: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			3: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			4: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			5: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
			6: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		}
	}
	componentDidMount () {
	}
	toggleEventButton = (activeIndex) => {
		this.setState({
			activeIndex
		})
	}
	render () {
		const { activeItem, toggleEvent } = this.props
		const { activeIndex } = this.state
		return (
			<div className="event__wrapper">
				<div className="event__content">
					<div className="upper__part">
						<div className="navigate">
							<span onClick={() => toggleEvent(null)}>
								←</span>
						</div>
						<div className="">
							<Heading title={activeItem.title} />
						</div>
						<div className="sub__body__text">
							{activeItem.desc}
						</div>
					</div>
					<div className="second__panel">
						<div className="left-panel">
							{Object.keys(this.eventDetails).map((key) => {
								// console.log("key", key, activeIndex)
								return <div onClick={() => this.toggleEventButton(key)} id={key} className={`__item ${activeIndex === key ? "active__item" : ""}`}>
									<span>Event {key}</span>
								</div>
							})}
						</div>
						<div className="right-panel">
							<div className="panel__desc">
								Event {activeIndex}: {this.eventDetails[activeIndex]}
							</div>
							<div className="navigate_button">
								<Button title="RSVP" />
								<Button title="AGENDA" />
								<Button title="sponsorship" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

Event.propTypes = {
	activeItem: PropTypes.object,
	toggleEvent: PropTypes.object
}
export default Event



// WEBPACK FOOTER //
// ./src/components/EventComponent/index.js